import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as PasswordResetSvg } from '../../assets/password-reset.svg';

export const PasswordResetIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={PasswordResetSvg} {...props} />;
};
